import { render } from "./DISCWheel.vue?vue&type=template&id=89f2bea2"
import script from "./DISCWheel.vue?vue&type=script&lang=js"
export * from "./DISCWheel.vue?vue&type=script&lang=js"
script.render = render

export default script